import { CheckboxField, DropdownField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EPublishPeriod, IJsonQueryTerm } from '../../../../json_query';
import { changePublishPeriod } from '../../../state/advanced/publish_period';
import { InlineParam, Row } from '../markup';
import { getTermValue } from '../../../../json_query/reducers/helpers';
import { changeWithPhoto } from '../../../state/with_photo';
import { changeHasVideo } from '../../../state/video';

export interface IPublishPeriodProps {
  publishPeriod: IJsonQueryTerm<EPublishPeriod> | undefined;
  onChanged(value: EPublishPeriod): void;
  photoValue: boolean;
  videoValue: boolean;
  onVideoChange(value: boolean): void;
  onPhotoChanged(value: boolean | undefined): void;
}

const checkboxStyle = { marginLeft: '16px' };

export const CoworkingPublishPeriod: React.StatelessComponent<IPublishPeriodProps> = props => (
  <Row title="Дата публикации объявлений">
    <InlineParam>
      <DropdownField
        value={(props.publishPeriod && props.publishPeriod.value) || 0}
        onValueChange={(value: EPublishPeriod) => props.onChanged(value)}
        values={[
          { value: EPublishPeriod.Any, label: 'За любую дату' },
          { value: EPublishPeriod.Today, label: 'Сегодня' },
          { value: EPublishPeriod.Hour, label: 'За час' },
          { value: EPublishPeriod.Day, label: 'За сутки' },
          { value: EPublishPeriod.TenDays, label: 'За 10 дней' },
          { value: EPublishPeriod.Month, label: 'За месяц' },
        ]}
      />
      <CheckboxField
        onValueChange={props.onPhotoChanged}
        value={props.photoValue}
        label="Только с фото"
        containerStyle={checkboxStyle}
      />
      <CheckboxField
        onValueChange={props.onVideoChange}
        value={props.videoValue}
        label="Только с видео"
        containerStyle={checkboxStyle}
      />
    </InlineParam>
  </Row>
);

export const mapStateToProps = (state: IAppState) => ({
  publishPeriod: state.filters.jsonQuery.publish_period,
  videoValue: Boolean(getTermValue('has_video')(state.filters.jsonQuery)),
  photoValue: state.filters.jsonQuery.wp && state.filters.jsonQuery.wp.value,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChanged: (value: EPublishPeriod) => {
    dispatch(changePublishPeriod(value));
  },
  onPhotoChanged: (value: boolean | undefined) => {
    dispatch(changeWithPhoto(value));
  },
  onVideoChange: (value: boolean) => dispatch(changeHasVideo(value)),
});

// tslint:disable-next-line:no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(CoworkingPublishPeriod);
